const gsv = window.LOCAL_CONFIG.UC_GSV
/**
 * 获取验证信息
 * @returns {*}
 */
export function getAuthority (option) {
  return window.fetch.post(gsv + '/ws/user/getAuthority', option)
}

/**
 * 获取验证信息
 * @returns {*}
 */
export function sendAithEmail (option) {
  return window.fetch.post(gsv + '/ws/user/send_auth_email', option)
}

/**
 * 发送短信验证码
 * @returns {*}
 */
export function sendPhoneCode (option) {
  return window.fetch.post(gsv + '/ws/user/send_phone_code', option)
}

/**
 * 认证手机号
 * @returns {*}
 */
export function authMobile (option) {
  return window.fetch.post(gsv + '/ws/user/auth_mobile', option)
}

/**
 * 发送修改密码邮件
 * @returns {*}
 */
export function sendPwdEmail (option) {
  return window.fetch.post(gsv + '/ws/user/send_pwd_email', option)
}

/**
 * 忘记密码密码邮件认证
 * @returns {*}
 */
export function validateLink (option) {
  return window.fetch.post(gsv + '/ws/user/validate_link', option)
}

/**
 * 邮箱认证
 * @returns {*}
 */
export function authEmailSuccess (option) {
  return window.fetch.post(gsv + '/ws/user/auth_email_success', option)
}

/**
 * 发送邮箱修改链接
 * @returns {*}
 */
export function sendUpdateEmail (option) {
  return window.fetch.post(gsv + '/ws/user/send_update_email', option)
}
/**
 * 发送邮箱修改链接
 * @returns {*}
 */
export function emailActivate (option) {
  return window.fetch.post(gsv + '/ws/user/email_activate', option)
}
